import { PayloadRequest } from 'types/requestTypes'
import { omdApi } from '../../api'

import { } from '../types/cashFlow'
import { CashFlowExpenseAccountItem } from '../types/cashFlowExpenseAccount'

const cashFlowSchemas = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getCashFlowExpenseAccount: builder.query<CashFlowExpenseAccountItem, PayloadRequest>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseAccount/${data.id}`,
      }),
    }),
    changeCashFlowExpenseAccount: builder.mutation<void, PayloadRequest & CashFlowExpenseAccountItem>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseAccount/${data.id}`,
        method: 'PUT',
        body: data
      }),
    }),
    createCashFlowExpenseAccount: builder.mutation<void, CashFlowExpenseAccountItem>({
      query: (data) => ({
        url: `/v1/CashFlowExpenseAccount/`,
        method: 'POST',
        body: data
      }),
    }),
  }),
})

export const {
  useChangeCashFlowExpenseAccountMutation,
  useCreateCashFlowExpenseAccountMutation,
  useGetCashFlowExpenseAccountQuery,
  useLazyGetCashFlowExpenseAccountQuery,
} =
cashFlowSchemas
